var map = {
  "./config/dashpanels": "71185",
  "./modules/admin/dashpanels": "84152",
  "./modules/gndo/dashpanels": "80173",
  "./modules/pagebox/dashpanels": "1313",
  "./modules/restriction/dashpanels": "70611",
  "./modules/stats/dashpanels": "6324",
  "./modules/timeline/dashpanels": "61916"
};



function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then((id) => (__webpack_require__(id)));
}
function __rspack_async_context_resolve(req) {
  return Promise.all(/* lazy-once context | core */ [__webpack_require__.e("rbush-node_modules_rbush_rbush_min_js"), __webpack_require__.e("vendors-node_modules_kevinseghetti-react-cursor-position_dist_es_ReactCursorPosition_js-node_-277bf7"), __webpack_require__.e("src_modules_serverlog_utils_js-src_tree_rules_js-src_viewer_layouts_js"), __webpack_require__.e("core")]).then(() => {
if(!__webpack_require__.o(map, req)) {
  var e = new Error("Cannot find module '" + req + "'");
  e.code = 'MODULE_NOT_FOUND';
  throw e;
}
return map[req];
});
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 65105;
module.exports = __rspack_async_context;
